import { render, staticRenderFns } from "./NotifiactionModal.vue?vue&type=template&id=f166fa26&scoped=true&"
import script from "./NotifiactionModal.vue?vue&type=script&lang=ts&"
export * from "./NotifiactionModal.vue?vue&type=script&lang=ts&"
import style0 from "./NotifiactionModal.vue?vue&type=style&index=0&id=f166fa26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f166fa26",
  null
  
)

export default component.exports